import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles({ name: "WorkspaceConfigurationPanel" })((theme: Theme) => ({
    stack: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        width: "100%",
    },
    // Single column on purpose. In a multi-column grid each switch ends up closer to the next
    // column's label than to its own, which reads as if it controlled the neighbouring setting.
    settingList: {
        display: "flex",
        flexDirection: "column",
        rowGap: theme.spacing(2),
        width: "100%",
    },
    cardTitle: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        minWidth: 0,
    },
    pageIcon: {
        width: 20,
        textAlign: "center",
        color: theme.palette.text.secondary,
        flexShrink: 0,
        marginRight: theme.spacing(2),
    },
    // Every row in a card is laid out the same way — label on the left, switch on the right edge — so
    // that the switches line up in one column. Never indent a subset of the rows: an offset switch
    // reads as belonging to something else than the rows above it.
    control: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: theme.spacing(2),
        width: "100%",
        minWidth: 0,
        margin: 0,
        "& .MuiFormControlLabel-label": {
            flex: 1,
            minWidth: 0,
        },
    },
    label: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        color: theme.palette.text.primary,
        minWidth: 0,
    },
    labelDisabled: {
        color: theme.palette.text.disabled,
    },
    shieldIcon: {
        color: theme.palette.warning.main,
        fontSize: 18,
    },
}));
